import inherits from "inherits";

import RuleProvider from "diagram-js/lib/features/rules/RuleProvider";

import FrendsElementTooltip from "./FrendsElementTooltip";
import { FrendsRuleProvider, ValidationResult } from "./FrendsRuleProvider";

export default function FrendsRuleset(eventBus: any, frendsElementTooltip: any) {
  this.frendsElementTooltip = frendsElementTooltip;
  this.activeElement = null;
  this.currentTooltipId = null;
  RuleProvider.call(this, eventBus);

  this.canConnect = function (source: BpmnJsElement, target: BpmnJsElement, connection?: BpmnJsConnectionElement) {
    const result = FrendsRuleProvider.canConnect(source, target, connection);
    if (result) {
      const validationResult = result as ValidationResult;
      (this.frendsElementTooltip as FrendsElementTooltip).setTooltipMessage(validationResult.message, this.activeElement);
      return false;
    }
  };

  this.canCreateOrMove = function (element: BpmnJsElement, target: BpmnJsElement) {
    const result = FrendsRuleProvider.canCreateOrMove(element, target);
    if (result) {
      const validationResult = result as ValidationResult;
      (this.frendsElementTooltip as FrendsElementTooltip).setTooltipMessage(validationResult.message, this.activeElement);
      return false;
    }
  };
}

inherits(FrendsRuleset, RuleProvider);
FrendsRuleset.$inject = ["eventBus", "frendsElementTooltip"];

// init is called by the rule provider, this is where rules should be initiated:
FrendsRuleset.prototype.init = function () {
  const self = this;
  this.addRule("connection.create", 1500, function (context: BpmmConnectionChangeContext) {
    const source = context.source,
      target = context.target;
    self.activeElement = target;
    return self.canConnect(source, target);
  });

  this.addRule("connection.reconnect", 1500, function (context: BpmmConnectionChangeContext) {
    const connection = context.connection,
      source = context.source,
      target = context.target;

    self.activeElement = source;
    return self.canConnect(source, target, connection);
  });


  this.addRule("shape.create", 1500, function (context: BmmnShapeCreationContext) {
    self.activeElement = context.target;
    return self.canCreateOrMove(context.shape, context.target);

  });

  this.addRule("shape.append", 1500, function (context: BmmnShapeCreationContext) {
    self.activeElement = context.target;
    if (context.target && context.target.type === "bpmn:SequenceFlow") {
      return false; // do not allow appending on sequence flows - can create loops
    }
  });

  this.addRule("elements.move", 1500, function (context: BpmnElementsMoveContext) {
    self.activeElement = context.target;
    for (const element of context.shapes) {
      const result = self.canCreateOrMove(element, context.target);

      if (result === false) {
        return false;
      }
    }
  });
};
